import { useModal } from '@flecto/ui';

import { ModalReopenInquiry, type ModalReopenInquiryProps } from './ModalReopenInquiry';

export function useModalReopenInquiry() {
  return (
    useModal<ModalReopenInquiryProps>({
      modalComponent: (props) => <ModalReopenInquiry {...props} />,
    })
  )
}
